import { defaultOffset } from "./defaultOffset";
import { normalizeValueWithProperty } from "./normalizeValueWithProperty";
function normalizeShadow({
  shadowColor,
  shadowOffset,
  shadowOpacity = 1,
  shadowRadius
}) {
  const { height, width } = shadowOffset || defaultOffset;
  return {
    shadowOffset: {
      width: normalizeValueWithProperty(width || 0),
      height: normalizeValueWithProperty(height || 0)
    },
    shadowRadius: normalizeValueWithProperty(shadowRadius || 0),
    shadowColor,
    shadowOpacity
  };
}
export {
  normalizeShadow
};
//# sourceMappingURL=normalizeShadow.js.map
